var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-blank btn-transparent btn-help",attrs:{"type":"button","tabindex":"0"}},[_c('icon',{attrs:{"name":"question"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }